<template>
  <div>
    <div>
      <div>
        <el-input :type="inputType"
                  :value="inputVal"
                  @change="change"
                  @input="input"
                  clearable
                  v-bind="$attrs"
                  ref="input"
                  :placeholder="placeholder"
                  validate-event
                  :style="[inputStyle]">
          <el-select v-model="select"
                     slot="prepend"
                     v-bind="prepend"
                     :style="[prepend.style]"
                     @change="handleChange">
            <el-option v-for="(item, index) in option"
                       :key="index"
                       :label="item[props.label]"
                       :value="item[props.value]">
            </el-option>
          </el-select>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
import formStore from "@/mixins/formStore.js";
export default {
  mixins: [formStore],
  props: {
    toolContent: {
      type: String
    },
    placeholder: {
      type: String,
      default: "请输入内容"
    },
    inputType: {
      type: String,
      value: "text"
    },
    scope: {
      type: Object
    },
    inputStyle: {
      type: Object
    },
    prepend: {
      type: Object
    },
    props: {
      default () {
        return {
          label: "label",
          value: "value"
        };
      }
    }
  },
  data () {
    return {
      inputVal: this.value[0],
      select: this.value[1]
    };
  },
  computed: {
    option () {
      let val = this.prepend && this.prepend.options;
      if (typeof val !== "function" && !val.then) {
        return this.prepend.options;
      } else {
        return [];
      }
    }
  },
  methods: {
    change (val) {
      this.inputVal = val;
      this.selfData = [this.inputVal, this.select];
      !this.delay && this.setVal();
      this.$emit("change", val);
      this.scope && this.scope.change && this.scope.change(val);
    },
    input (val) {
      this.inputVal = val;
    },
    handleChange (val) {
      this.select = val;
      this.inputVal = "";
      this.$emit("change", { val, type: "prepend" });
    }
  },
  components: {}
};
</script>

<style scoped></style>
